import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, HostListener, Inject, Injector, Output, OnInit, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { ApiService } from '../../service/api.service';
import { DataServiceService } from '../../service/data-share.service';
import { HttpClient } from '@angular/common/http';
import { CommonService } from '../../service/common.service';
import { Location } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    CommonModule,
    MatToolbarModule,
    MatIconModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Output() menu = new EventEmitter<void>();
  isSticky: boolean = false;
  mobileMenuOpen: boolean = false;
  userData: any;
  isShow: boolean = true;

  @HostListener('window:scroll')
  onWindowScroll() {
    if (typeof window !== 'undefined') {
      this.isSticky = window.scrollY > 10;
    }
  }

  toggleMobileMenu() {
    this.mobileMenuOpen = !this.mobileMenuOpen;
    if (typeof document !== 'undefined') {
      document.body.style.overflow = this.mobileMenuOpen ? 'hidden' : '';
    }
  }

  allCategoryData: any[] = [];
  cartData: any = 0;
  locationSelected: any = 'Lucknow';
  locationData: any = [];
  city: any = '';
  headerSearch:any;
  searchSubject: Subject<string> = new Subject<string>();
  searchSubscription!: Subscription;

  constructor(
    private location: Location,
    private injector: Injector,
    private router: Router,
    private api: ApiService,
    private dataShare: DataServiceService,
    private http: HttpClient,
    private common: CommonService,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      if (localStorage.getItem('userData')) {
        const u: any = localStorage.getItem('userData');
        this.userData = JSON.parse(u || null);
      }
    }
    this.city = this.common.getLocation()?.city || '';
  }

  ngOnInit(): void {
    this.getCategoryData();
    this.getCartData();
    this.dataShare.stringSubject.subscribe((data) => {
      this.getCartData();
    });

    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe(searchValue => {
      if(searchValue && searchValue.trim().length > 0) {
        this.gotoSearch();
      }
    });
  }

  onSearchInput(value: string) {
    this.searchSubject.next(value);
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
  }

  gotoSearch(){
    setTimeout(() => {
      this.headerSearch = '';
    }, 3000);
    this.router.navigate(['/search'], {queryParams:{key:this.headerSearch}})
    
  }


  getCartData() {
    if (this.userData)
      this.api
        .commonPostfun('product/get/addToCart/count', {
          user_id: this.userData.id,
        })
        .subscribe((res: any) => {
          if (res.status && res?.response.length > 0) {
            this.cartData = res.response[0].totalNum;
          }
        });
  }
  gotoCartView(ele: any) {
    if (ele > 0) this.router.navigate(['/product/cart-view']);
  }

  ngDoCheck() {
    if (
      this.location.path().search('account') == 1 ||
      this.location.path().search('home') != 1
    ) {
      this.isShow = false;
    } else {
      this.isShow = true;
    }
    if (this.location.path().search('home') == 1) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  getCategoryData() {
    const body = {
      page: 0,
      pageSize: 50,
    };
    this.api.commonPost('fetch/category', body).subscribe(
      (res: any) => {
        if (res.status && res.statusCode == 200) {
          res.response.forEach((ele: any) => {
            ele.url = this.api.imageUrl + ele.url;
          });
          this.allCategoryData = res.response.sort(
            (a, b) => (a.displayOrder ?? 0) - (b.displayOrder ?? 0)
          );
        } else {
          this.allCategoryData = [];
        }
      },
      (error) => console.log(error)
    );
  }

  async openFreeListingSeller() {
    const [{ MatDialog }, { FreeListingComponent }] = await Promise.all([
      import('@angular/material/dialog'),
      import('../../shared/free-listing/free-listing.component')
    ]);
    const dialog = this.injector.get(MatDialog);
    const dialogRef = dialog.open(FreeListingComponent, {
      width: '600px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        if (localStorage.getItem('userData')) {
          const u: any = localStorage.getItem('userData');
          this.userData = JSON.parse(u || null);
        }
        this.city = this.common.getLocation().city;
      }
    });
  }
  async openFreeListingBuyer() {
    const [{ MatDialog }, { ForBuyerComponent }] = await Promise.all([
      import('@angular/material/dialog'),
      import('../../shared/for-buyer/for-buyer.component')
    ]);
    const dialog = this.injector.get(MatDialog);
    const dialogRef = dialog.open(ForBuyerComponent, {
      width: '500px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        if (localStorage.getItem('userData')) {
          const u: any = localStorage.getItem('userData');
          this.userData = JSON.parse(u || null);
        }
        this.city = this.common.getLocation().city;
      }
    });
  }
  openPlans() {
    this.router.navigateByUrl('/plans');
  }

  gotoLeads(){
      this.router.navigateByUrl('/leads');
  }

  async openLoginDialog() {
    const [{ MatDialog }, { LoginComponent }] = await Promise.all([
      import('@angular/material/dialog'),
      import('../../shared/login/login.component')
    ]);
    const dialog = this.injector.get(MatDialog);
    const dialogRef = dialog.open(LoginComponent, {
      width: '400px',
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      if (res) {
        if (localStorage.getItem('userData')) {
          const u: any = localStorage.getItem('userData');
          this.userData = JSON.parse(u || null);
        }
        this.city = this.common.getLocation().city;
      }
    });
  }

  gotoLogOut() {
    localStorage.clear();
    sessionStorage.clear();
    this.userData = null;
    this.router.navigate(['/']);
  }

  gotoHiring() {
    window.open('https://btechmart.in/job/employee-login.aspx', '_blank');
  }

  gotoMyLeads() {
    this.router.navigate(['/account/my-leads']);
  }
  gotoMyDashboard() {
    this.router.navigate(['/account']);
  }
  gotoMyPro() {
    this.router.navigate(['/account/add-product']);
  }
  gotoMyOrders() {
    this.router.navigate(['/account/my-order']);
  }

  gotoDetails() {
    this.router.navigate(['/account/company-details']);
  }

gotoTabs(data: any): void {
  if (
    data.name === 'Raw Material' ||
    data.name === 'Construction' ||
    data.name === 'Interior' ||
    data.name === 'Apparel & Garments' ||
    data.name === 'Industrial Plants Machinery' ||
    data.name === 'Design' ||
    data.name === 'Agriculture & Farming' ||
    data.name === 'Handicrafts & Decoratives' ||
    data.name === 'Hand & Machine Tools' ||
    data.name === 'Jewelry & Astrology' || 
    data.name === 'Pharmaceuticals'
  ) {
    
    const seoCategory = this.common.createSlugUrl(data.name);
    this.router.navigate(['/service', seoCategory])
      .then(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));

  } else if (data.name === 'Medicine') {
    window.open('https://www.bpharmastore.com/', '_blank');

  } else if (data.name === 'Wedding') {
    this.router.navigate(['/weddings'])
      .then(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));

  } else if (data.name === 'Hotels') {
    this.router.navigate(['/hotels-list', this.city])
      .then(() => window.scrollTo({ top: 0, left: 0, behavior: 'instant' }));

  } else if (data.name === 'Web Development' || data.name === 'IT Solutions') {
    window.open('https://btechsoftwares.com/', '_blank');
  }
}
  gotoLinksCard(cartData: any) {
    if (cartData > 0) {
      this.router.navigate(['/cart']);
    }
  }

  gotoLinks(url: any) {
    this.router.navigate([url]);
  }

  scrollCatLeft() {
    const el = this.document.getElementById('cat-scroll-area');
    if (el) el.scrollBy({ left: -240, behavior: 'smooth' });
  }

  scrollCatRight() {
    const el = this.document.getElementById('cat-scroll-area');
    if (el) el.scrollBy({ left: 240, behavior: 'smooth' });
  }
}
